<h1 mat-dialog-title>Setting</h1>

<div mat-dialog-content>
    <mat-form-field appearance="outline" class="p-2">
        <mat-label>{{data.settingKey}}</mat-label>
        <input matInput [(ngModel)]="data.settingValue">
    </mat-form-field>
</div>

<div mat-dialog-actions class="float-right">
    <button mat-flat-button (click)="onCancelClick()" class="error shade border-2">Cancel</button>
    <button mat-flat-button [mat-dialog-close]="data" class="shade border-2" cdkFocusInitial>Save</button>
</div>